export const RETAIL_LABELS = {
	title: 'For Retail Buyers',
	content_subititle: 'Connecting with Brands at Expo and Beyond',
	highlight_content:
		'Beacon Discovery brings the trusted product discovery of Expo West online—connecting retailers with high-quality natural and organic brands year-round.',
	content1:
		'With 20,000+ curated products and 100+ filters powered by SPINS, it’s easier than ever to find items that align with your values and drive business growth.',
	content2:
		'Enhanced by insights from partners like HowGood and MarketReady Verified, you can evaluate products for sustainability and compliance with confidence.',
	videoLink: '799609843',
	videoHash: '404bcffb88'
};
